import { metricsBus, SearchResultSection } from "@/common/buses";
import localMetrics from "@/common/services/localMetrics/localMetrics";

metricsBus.on("gifView", (props) => localMetrics.sendGifView(props));
metricsBus.on("gifPlayback", (props) => localMetrics.sendGifPlayback(props));
metricsBus.on("gifVideoLoad", (props) => localMetrics.sendGifVideoLoad(props));
metricsBus.on("gifShared", (props) => localMetrics.sendGifShared(props));
metricsBus.on("addedToCollection", (props) => localMetrics.sendGifAddedToCollection(props));
metricsBus.on("gifLiked", (props) => localMetrics.sendGifLiked(props));
metricsBus.on("profileClicked", (props) => localMetrics.sendProfileClicked(props));
metricsBus.on("followUserClicked", (props) => localMetrics.sendFollowUserClicked(props));
metricsBus.on("dailyVisit", (props) => localMetrics.sendDailyVisit(props));
metricsBus.on("boostProfileClicked", (props) => localMetrics.sendBoostProfileClicked(props));
metricsBus.on("liveCircleClicked", (props) => localMetrics.sendLiveCircleClicked(props));
metricsBus.on("paidLinksClicked", (props) => localMetrics.sendPaidLinksClicked(props));
metricsBus.on("paidLinksViewed", (props) => localMetrics.sendPaidLinksViewed(props));
metricsBus.on("searchResultClicked", (props) => {
  if (props.section !== SearchResultSection.Niche) {
    return;
  }

  localMetrics.sendNicheSearched(props.title);
});

metricsBus.on("searchQuerySubmitted", (props) => {
  if (props.queryType !== "Niche" || !props.itemId) {
    return;
  }

  localMetrics.sendNicheSearched(props.itemId);
});

metricsBus.on("liveCamClicked", (props) => localMetrics.sendLiveCamClicked(props));
metricsBus.on("liveCamView", (props) => localMetrics.sendLiveCamView(props));

metricsBus.on("embedRevenueLinkClicked", (props) => localMetrics.sendEmbedRevenueLinkClicked(props));
metricsBus.on("playerSocialLinkClicked", (props) => localMetrics.sendPlayerSocialLinkClicked(props));
metricsBus.on("socialProfileClicked", (props) => {
  if (!props.originGif || !props.originGif.promoted) {
    return;
  }

  localMetrics.sendProfileRevenueLinkClicked(props);
});

metricsBus.on("feedSwitched", (props) => localMetrics.sendFeedSwitched(props));
